import cn from 'clsx';

import s from './Basic.module.scss';

export type BadgeColorType = 'violet' | 'gray' | 'pink' | 'blue' | 'red' | 'orange' | 'green' | 'cornflower' | 'magenta';

export interface BasicBadgeProps {
  color: BadgeColorType;
  text: string;
  className?: string;
}

function Basic({ color = 'violet', text, className }: BasicBadgeProps) {
  return (
    <span className={cn(s.span, s[color], className)}>
      <span className={s.ellipsis}>{text}</span>
    </span>
  );
}

export default Basic;
